
<div class="customizable-radio-button" :class="containerClasses">
  <input
    :id="id"
    class="input"
    type="radio"
    :checked="isSelected"
    :disabled="disabled"
    :name="name"
    :value="value"
    @change="handleChange"
  />
  <label :for="id" class="radio-label">
    <!-- Bande colorée à gauche -->
    <div class="accent-band" />

    <!-- Cercle radio -->
    <div class="radio-circle">
      <!-- Point de sélection (visible seulement si sélectionné) -->
      <div v-if="isSelected" class="radio-dot" />
    </div>

    <!-- Contenu principal -->
    <span class="content">
      <span v-if="title" class="title">{{ title }}</span>
      <span v-if="description" class="description">{{ description }}</span>

      <!-- Slot pour contenu personnalisé -->
      <div v-if="$slots.content" class="slot-content">
        <slot name="content" />
      </div>

      <!-- Slot par défaut -->
      <div v-if="$slots.default" class="slot-default">
        <slot />
      </div>
    </span>

    <!-- Slot pour contenu à droite (ex: icône, badge) -->
    <span v-if="$slots.right" class="right-container">
      <slot name="right" />
    </span>
  </label>
</div>
